<template>
  <v-card
    max-width="850"
    class="mx-auto my-10 pb-10"
    v-infinite-scroll="loadMore"
    :infinite-scroll-disabled="loading"
    infinite-scroll-distance="100"
  >
    <v-list two-line>
      <template v-for="(item, index) in items">
        <v-subheader v-text="item.header" :key="item.header"></v-subheader>

        <div v-if="item.data.length > 0" :key="index">
          <template v-for="notif in item.data">
            <v-list-item v-if="notif.type == type.newUser" :key="notif.id">
              <v-list-item-content>
                <v-list-item-title>
                  {{ notif.message }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-html="notif.diffForHuman"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn @click="goToUser(notif.user)" icon>
                  <v-icon>{{ icons.goTo }}</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider :key="notif.id + 'divider'"></v-divider>
          </template>
        </div>

        <div v-else :key="index">
          <v-list-item>
            <v-list-item-content>
              <v-alert
                color="blue lighten-4"
                border="left"
                elevation="2"
                colored-border
                :icon="icons.bellSleep"
                >There are no recent activities.</v-alert
              >
            </v-list-item-content>
          </v-list-item>
        </div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  mdiDotsVertical,
  mdiBellSleep,
  mdiSubdirectoryArrowRight
} from '@mdi/js'
import { findIndex } from 'lodash'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  name: 'NotificationList',

  directives: {
    infiniteScroll
  },

  data() {
    return {
      loading: false,
      icons: {
        dotVertical: mdiDotsVertical,
        bellSleep: mdiBellSleep,
        goTo: mdiSubdirectoryArrowRight
      },
      items: [
        {
          header: 'New',
          data: []
        },
        {
          header: 'Earlier',
          data: []
        }
      ],
      type: {
        newUser: 'new_user'
      }
    }
  },

  created() {
    this.clearNotifications()
    this.fetchNotifications()
  },

  computed: {
    ...mapState({
      newNotifs: state => state.notification.newList,
      earlierNotifs: state => state.notification.earlierList,
      listMeta: state => state.notification.listMeta
    }),

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getNotifications: 'notification/getNotifications'
    }),

    ...mapMutations({
      clearNotifications: 'notification/clearNotificationList'
    }),

    goToUser(user) {
      this.$router.push({
        name: 'user.details',
        params: {
          id: user.id
        }
      })
    },

    pageChanged(page) {
      this.fetchNotifications(page)
    },

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchNotifications(this.listMeta.current_page + 1)
      }
    },

    async fetchNotifications(page = 1) {
      if (this.loading) return
      let params = { page }

      this.loading = true
      await this.getNotifications(params)
        .then(() => {
          let newIndex = findIndex(this.items, { header: 'New' })
          let earlierIndex = findIndex(this.items, { header: 'Earlier' })

          this.items[newIndex].data = this.newNotifs
          this.items[earlierIndex].data = this.earlierNotifs

          this.loading = false
        })
        .catch(error => {
          if (error.response && error.response.status === 403) {
            this.logout()
          }
        })
    },

    actorThumbSrc(avatar) {
      return avatar
        ? avatar.url
        : require('@/assets/images/default-profile.png')
    }
  }
}
</script>
